<template>
    <v-select
        v-if="type == 'v-select'"
        v-focus="focus ? focus : false"
        ref="dropdownSelect"
        v-model="answer"
        v-bind="$attrs"
        v-on="$listeners"
        :label="`${$attrs.label}${($attrs['set-rules'] || '').includes('required') ? ' *' : ''}`"
        :items="setItems"
        item-value="item"
        item-text="item"
        :rules="ifValid(setRules)"
        :required="setRules.length > 0"
        :menu-props="menuPropsCombined"
        browser-autocomplete="no"
        :clearable="!($attrs['set-rules'] || '').includes('required')"
        :style="$attrs['set-max-width'] ? `max-width: ${$attrs['set-max-width']}px` : ''"
    >
        <template v-for="(_, slot) of $slots" :slot="[slot]">
            <slot :name="slot" />
        </template>
        <template v-for="(_, slot) of $scopedSlots" :slot="[slot]" slot-scope="data">
            <slot :name="slot" v-bind="data" />
        </template>
    </v-select>
    <v-text-field
        v-else-if="type == 'v-text-field'"
        v-model="answer"
        v-bind="$attrs"
        v-on="$listeners"
        :label="`${$attrs.label}${($attrs['set-rules'] || '').includes('required') ? ' *' : ''}`"
        :hide-details="$attrs['hide-details'] ? true : false"
        :rules="ifValid(setRules)"
        :required="setRules.length > 0"
        :style="$attrs['set-max-width'] ? `max-width: ${$attrs['set-max-width']}px` : ''"
        :type="($attrs['set-rules'] || '').includes('numeric') ? 'number' : 'text'"
    >
        <template v-for="(_, slot) of $slots" :slot="[slot]">
            <slot :name="slot" />
        </template>
        <template v-for="(_, slot) of $scopedSlots" :slot="[slot]" slot-scope="data">
            <slot :name="slot" v-bind="data" />
        </template>
    </v-text-field>
    <v-switch
        v-else-if="type == 'v-switch'"
        v-model="answer"
        v-bind="$attrs"
        v-on="$listeners"
        :label="`${$attrs.label}${answer ? ': ' + answer : ''}`"
        :true-value="true_value"
        :false-value="false_value"
    >
        <template slot="label">
            <span>{{ $attrs.label + (answer ? ":&nbsp;" : "") }}</span
            ><span class="fw-bold">{{ answer ? " " + answer : "" }}</span>
        </template>
    </v-switch>
</template>

<script>
//v-focus="$attrs.focus ? $attrs.items : false"
export default {
    props: ["focus", "value", "type", "setup"],
    data() {
        return {
            false_value: "",
            true_value: "",
        };
    },
    computed: {
        answer: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
        setItems() {
            let items = [];
            if (this.$attrs["set-items"]) {
                items = this.$attrs["set-items"];
            }
            return items;
        },
        setRules() {
            let rules = null;
            if (this.$attrs["set-rules"] && this.$attrs["set-rules"] != "") {
                rules = this.$attrs["set-rules"];
            }
            return this.evalRules(rules);
        },
        defaultPropsMenu() {
            return { auto: false };
        },
        menuPropsCombined() {
            // use propsMenu in order to avoid conflicts with v-bind="$attrs"
            let propsMenu = this.$attrs.propsMenu ? this.$attrs.propsMenu : null;
            return this.$attrs.propsMenu ? { ...this.defaultPropsMenu, ...propsMenu } : { ...this.defaultPropsMenu };
        },
    },
    mounted() {
        if (this.type == "v-switch") {
            let items = this.setItems.map((i) => i.item);
            this.false_value = items[0];
            this.true_value = items[1];
            this.$emit("input", this.true_value);
        } else {
            this.false_value = "";
            this.true_value = "";
        }
    },
    watch: {
        setup: function (newVal, oldVal) {
            if (newVal) {
                if (this.type == "v-switch") {
                    let items = this.setItems.map((i) => i.item);
                    this.false_value = items[0];
                    this.true_value = items[1];
                    this.$emit("input", this.true_value);
                } else {
                    this.false_value = "";
                    this.true_value = "";
                }
            }
        },
    },
};
</script>
